<script lang="ts" setup>
import type { PropType } from 'vue'
import type { THomeSectionSlider } from '~/layers/homepage/data/types'

defineProps({
  section: {
    type: Object as PropType<THomeSectionSlider>,
    required: true,
  },
})
</script>

<template>
  <div
    :class="{
      // 'fixed-panel_light': section.sliderType === 'brilliants' убрано в устной договоренности ALROSA-3577
    }"
    class="fixed-panel fixed-panel__pagination"
  >
    <div class="fixed-panel__body">
      <div class="fixed-panel__header">
        <p class="fixed-panel__title">{{ section.navigation.title }}</p>
        <p class="fixed-panel__subtitle">{{ section.navigation.subtitle }}</p>
      </div>
      <div class="fixed-panel__content">
        <div
          :class="{
            'fixed-panel__icon-links': section.sliderType === 'brilliants',
            'fixed-panel__links': section.sliderType === 'constructor',
          }"
        >
          <template v-for="(item, index) in section.slides" :key="'navigation_' + index">
            <a v-if="item.icon" :href="item.link" class="fixed-panel__icon-link fixed-panel__icon-link_active">
              <img :src="$h.externalAsset(item.icon)" alt="" />
            </a>
            <a v-else :href="item.link" class="fixed-panel__catalog-link">{{ item.name }}</a>
          </template>
        </div>
      </div>
      <div class="fixed-panel__footer">
        <nuxt-link :to="section.navigation.buttonLink" class="fixed-panel__link">
          {{ section.navigation.buttonText }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
